import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IDocumentRule } from "@/models/document-rule.entity";
import documentRuleService from "@/services/mrfiktiv/services/documentRuleService";
import { MrfiktivDocumentRuleControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const DocumentRulePageDataProvider = new (class extends AbstractPageDataProvider<
  IDocumentRule,
  MrfiktivDocumentRuleControllerGetParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivDocumentRuleControllerGetParamsGen): Promise<IPageViewModel<IDocumentRule>> {
    const res = await documentRuleService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IDocumentRule[];

    return { meta, data };
  }
})();
